<template>
      <apexchart v-bind:type="appproperties.type" :options="{legend: {show: false}}" :series="appproperties.series"></apexchart>
</template>
<script>
export default {
  name: 'defaultchart',
  props: ['appproperties', 'grid'],
  data: function() {
    return {};
  }
}
</script>
